export default "__VITE_ASSET__BGy2uRHl__"